import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { VenuesService } from '../venues.service';
import { ToastService } from '../../_core/services/toast.service';
import { Subject, takeUntil } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-create-venue',
  templateUrl: './create-venue.component.html',
  styleUrls: ['./create-venue.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
    TranslateModule
  ]
})
export class CreateVenueComponent {
  private modalController = inject(ModalController);
  private venuesService = inject(VenuesService);
  private toastService = inject(ToastService);
  private translateService = inject(TranslateService);

  form = new FormGroup({
    venueName: new FormControl('', Validators.required),
    venueAbbreviation: new FormControl('', Validators.required)
  })

  private readonly destroy$: Subject<void> = new Subject();

  async ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  create() {
    if (this.form.invalid) {
      this.toastService.presentDangerToast(this.translateService.instant('All fields are required'))
      return;
    }

    this.venuesService
      .create(this.form.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        venue => {
          this.modalController.dismiss(venue);
        }
      )

  }

  async close() {
    await this.modalController.dismiss();
  }
}
